export default __webpack_public_path__ + "static/media/Caption-closed.a228d52c.svg";